/**
 * Spec 10.2.1 — the 15-minute authorisation expiry countdown. Ticks each second;
 * under 5 minutes it switches to the warning treatment with the status-dot pulse
 * (the only motion). Expiry is handled by the list re-poll moving the row to
 * history — this component just shows the clock.
 */
import { useEffect, useState } from "react";
import { msUntil, mmss } from "./format";

export function Countdown({ expiresAt }: { expiresAt: string }) {
  // Tick once a second to force a re-render; ms is derived on each render so it
  // stays correct when `expiresAt` changes (no setState-of-derived-value).
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((v) => (v + 1) % 3600), 1000);
    return () => clearInterval(t);
  }, []);

  const ms = msUntil(expiresAt);
  const soon = ms > 0 && ms < 5 * 60 * 1000;
  const cls = ["countdown", soon ? "countdown--soon" : "", soon ? "pulse" : ""].filter(Boolean).join(" ");
  return (
    <span className={cls}>
      <span className="dot" />
      {mmss(ms)}
    </span>
  );
}
